import { Routes } from 'react-router-dom';
import { authRoutes } from './auth';
import { supplierRoutes } from './supplier';
import { partnerRoutes } from './partner';
import { adminRoutes } from './admin';
import { travelerRoutes } from './traveler';
import { publicRoutes } from './public';

export function AppRoutes() {
  return (
    <Routes>
      {authRoutes}
      {supplierRoutes}
      {partnerRoutes}
      {adminRoutes}
      {travelerRoutes}
      {publicRoutes}
    </Routes>
  );
}
